import { createFileRoute, redirect } from '@tanstack/react-router';

// Renamed to /reports. Kept as a redirect so existing bookmarks and deep links
// to /dashboard keep working.
export const Route = createFileRoute('/dashboard')({
  beforeLoad: () => {
    throw redirect({ to: '/reports' });
  },
});
